export default "__VITE_ASSET__401662a4__"